var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createaccount--signin-link"},[_c('p',{staticClass:"content-leadin"},[_vm._v(" Have an existing HomeGauge account? "),_c('router-link',{staticClass:"content-link",attrs:{"to":_vm.signinLink}},[_vm._v("Sign In")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }